// extracted by mini-css-extract-plugin
export default {"wrapper":"Presente_wrapper__bQ18Q","cardWrapper":"Presente_cardWrapper__anwa3"};